import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M17 5.5H4C2.89543 5.5 2 6.39543 2 7.5V14.5C2 15.6046 2.89543 16.5 4 16.5H17C18.1046 16.5 19 15.6046 19 14.5V7.5C19 6.39543 18.1046 5.5 17 5.5Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="10.5" cy="11" r="2" stroke={fill} strokeWidth="2" />
    <circle cx="5.5" cy="11" r="1" fill={fill} />
    <circle cx="15.5" cy="11" r="1" fill={fill} />
    <path
      d="M5 16.5V17.5C5 18.6046 5.89543 19.5 7 19.5H19C20.6569 19.5 22 18.1569 22 16.5V10.5C22 9.39543 21.1046 8.5 20 8.5H19"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

export default Icon;
